// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction6_wrapper__HScwJ","button":"introduction6_button__kivq8"};